<template>
    <v-navigation-drawer v-model="value" class="session__aside lighten-10" app :width="width" mobile-break-point="500">
        <v-btn class="session__aside-close" @click="$emit('input', false)" icon><v-icon>close</v-icon></v-btn>
        <slot></slot>
    </v-navigation-drawer>
</template>

<script>
    export default {
        props: {
            value: Boolean,
            width: {
                type: Number,
                default: 350
            }
        }
    }
</script>


<style lang="stylus">
    .session__aside {
        background-color #1c2429!important
        color #fff
        &-close {
            position absolute
            top 5px
            right 5px
            color #fff!important
        }
    }
    .navigation-drawer {
        padding: 40px 0 0 0!important;
    }
    .navigation-drawer__border {
        /*display: none;*/
    }
</style>
